export default "__VITE_ASSET__bmNG4cFg__"